import type { Dtos, USStateOrTerritory } from "@inrev/common";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { fredSnapshotPeriodQueryKey } from "../fred.keys";

export const useFetchFredSnapshot = (
	stateCode: USStateOrTerritory | undefined,
	changePeriod: Dtos.MarketIntelligence.Fred.Snapshot.ChangePeriod,
) => {
	const { get } = useRequest();

	return useQuery({
		queryKey: fredSnapshotPeriodQueryKey(stateCode, changePeriod),
		placeholderData: keepPreviousData,
		queryFn: async () => {
			const params = new URLSearchParams();
			if (stateCode !== undefined) params.append("stateCode", stateCode);
			params.append("changePeriod", changePeriod);
			const query = params.toString();

			return await get<Dtos.MarketIntelligence.Fred.Snapshot.Response>(
				`/v2/admin/market-intelligence/fred/snapshot${query === "" ? "" : `?${query}`}`,
			);
		},
	});
};
